/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';

import { TestId } from '@trello/webdriverio-tests';
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import styles from './header.less';
import { useFocusRing } from '@trello/a11y';

interface HeaderButtonProps {
  ariaLabel?: string;
  children?: React.ReactNode;
  className?: string;
  icon?: IconName;
  iconColor?: IconColor;
  onClick: React.MouseEventHandler;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  testId?: TestId;
  title?: string;
}

const HeaderButton: React.RefForwardingComponent<
  HTMLButtonElement,
  HeaderButtonProps
> = (
  {
    ariaLabel,
    children,
    className,
    icon,
    iconColor,
    onClick,
    onMouseEnter,
    onMouseLeave,
    testId,
    title,
  },
  ref,
) => {
  const [hasFocusRing, mouseEvents] = useFocusRing({
    onMouseEnter,
    onMouseLeave,
  });

  return (
    <button
      aria-label={ariaLabel}
      className={classNames(
        styles.headerButton,
        className,
        hasFocusRing && styles.focusRing,
      )}
      data-test-id={testId}
      ref={ref}
      title={title}
      onClick={onClick}
      {...mouseEvents}
    >
      {icon && (
        <Icon
          color={iconColor}
          medium
          name={icon}
          className={styles.headerButtonIcon}
        />
      )}
      {children}
    </button>
  );
};

export default React.forwardRef(HeaderButton);
